import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Auth } from '../services/auth';

export const authGuard: CanActivateFn = async () => {
  const auth = inject(Auth);
  const router = inject(Router);

  // Wait for Firebase Auth to restore session (resolves only once, instant on subsequent calls)
  await auth.authReady;

  if (auth.isAuthenticated()) return true;
  return router.createUrlTree(['/auth']);
};
